import { LoginLayout } from "../layouts";
import {  ResetPasswordEmailForm } from "../containers";

const ResetPasswordEmail = () => {

    return (

        <div className="p-3">
            <LoginLayout>
                <ResetPasswordEmailForm />
            </LoginLayout>
        </div>



    )

}


export default ResetPasswordEmail;